import SocialLinks from "components/SocialLinks"
import Image from "next/image"
import useT from "utils/useT"

const AboutUs = () => {
  const t = useT()
  return (
    <div>
      <div className="card card-style">
        <div className="content">
          <div className="d-flex">
            <div>
              <Image
                src="/images/icons/freeapps-512.png"
                width={50}
                height={50}
                className="me-3 rounded-sm"
                alt="appollow icon"
                unoptimized
              />
            </div>
            <div>
              <h1 className="mb-0 pt-1">APPOLLOW</h1>
              <p dir={t.dir} className="color-highlight font-11 mt-n2 mb-3">
                {t.about.subheader}
              </p>
            </div>
          </div>
          <p dir={t.dir}>{t.about.description}</p>
        </div>
      </div>

      <div className="card bg-20 mt-4 card-style">
        <div className="card-body">
          <h3 className="color-white font-600 pt-3" dir="auto">
            {t.about.heading3}
          </h3>
          <p className="color-white opacity-70" dir="auto">
            {t.about.heading3sub}
          </p>
          <div className="card card-style ms-0 me-0 bg-white">
            <div className="row mt-3 pt-1 mb-3">
              <div
                className="col-6 d-flex"
                style={{
                  flexDirection: t.dir === "rtl" ? "row-reverse" : "row",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-smartphone float-start ms-3 me-3"
                  data-feather-line={1}
                  data-feather-size={35}
                  data-feather-color="green-dark"
                  data-feather-bg="green-fade-light"
                  style={{ strokeWidth: 1, width: "35px", height: "35px" }}
                >
                  <rect x={5} y={2} width={14} height={20} rx={2} ry={2} />
                  <line x1={12} y1={18} x2="12.01" y2={18} />
                </svg>
                <h4 className="color-black float-start font-14 font-500 line-height-s pb-3 mb-3 text-break">
                  {t.about.about1}
                </h4>
              </div>
              <div
                className="col-6 d-flex"
                style={{
                  flexDirection: t.dir === "rtl" ? "row-reverse" : "row",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-star float-start ms-3 me-3"
                  data-feather-line={1}
                  data-feather-size={35}
                  data-feather-color="yellow-dark"
                  data-feather-bg="yellow-fade-light"
                  style={{ strokeWidth: 1, width: "35px", height: "35px" }}
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <h4 className="color-black float-start font-14 font-500 line-height-s pb-3 mb-3 text-break">
                  {t.about.about2}
                </h4>
              </div>
              <div
                className="col-6 d-flex"
                style={{
                  flexDirection: t.dir === "rtl" ? "row-reverse" : "row",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-life-buoy float-start ms-3 me-3"
                  data-feather-line={1}
                  data-feather-size={35}
                  data-feather-color="blue-dark"
                  data-feather-bg="blue-fade-light"
                  style={{ strokeWidth: 1, width: "35px", height: "35px" }}
                >
                  <circle cx={12} cy={12} r={10} />
                  <circle cx={12} cy={12} r={4} />
                  <line x1="4.93" y1="4.93" x2="9.17" y2="9.17" />
                  <line x1="14.83" y1="14.83" x2="19.07" y2="19.07" />
                  <line x1="14.83" y1="9.17" x2="19.07" y2="4.93" />
                  <line x1="14.83" y1="9.17" x2="18.36" y2="5.64" />
                  <line x1="4.93" y1="19.07" x2="9.17" y2="14.83" />
                </svg>
                <h4
                  dir="auto"
                  className="color-black float-start font-14 font-500 line-height-s text-break"
                >
                  {t.about.about3}
                </h4>
              </div>
              <div
                className="col-6 d-flex"
                style={{
                  flexDirection: t.dir === "rtl" ? "row-reverse" : "row",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-code float-start ms-3 me-3"
                  data-feather-line={1}
                  data-feather-size={35}
                  data-feather-color="green-dark"
                  data-feather-bg="none"
                  style={{ strokeWidth: 1, width: "35px", height: "35px" }}
                >
                  <polyline points="16 18 22 12 16 6" />
                  <polyline points="8 6 2 12 8 18" />
                </svg>
                <h4
                  dir="auto"
                  className="color-black float-start font-14 font-500 line-height-s text-break"
                >
                  {t.about.about4}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="card-overlay bg-highlight opacity-95" />
        <div className="card-overlay dark-mode-tint" />
      </div>
      <div className="card card-style">
        <div className="content text-center">
          <h2 dir="auto">{t.about.features}</h2>
          <p dir="auto" className="boxed-text-xl">
            {t.about.featuresSub}
          </p>
        </div>
        <div className="divider divider-small mb-3 bg-highlight" />
        <div className="content">
          <div
            className="d-flex mb-4 pb-3"
            style={{
              flexDirection: t.dir === "rtl" ? "row-reverse" : "row",
            }}
          >
            <div>
              <i className="far fa-star color-yellow-dark fa-3x pt-3 icon-80 text-center" />
            </div>
            <div>
              <h5 dir="auto" className="font-16 font-600">
                {t.about.feature1}
              </h5>
              <p dir="auto">{t.about.feature1sub}</p>
            </div>
          </div>
          <div
            className="d-flex mb-4 pb-3"
            style={{
              flexDirection: t.dir === "rtl" ? "row-reverse" : "row",
            }}
          >
            <div>
              <i className="fa fa-mobile-alt color-blue-dark fa-3x pt-3 icon-80 text-center" />
            </div>
            <div>
              <h5 dir="auto" className="font-16 font-600">
                {t.about.feature2}
              </h5>
              <p dir={t.dir}>{t.about.feature2sub}</p>
            </div>
          </div>
          <div
            className="d-flex mb-2"
            style={{
              flexDirection: t.dir === "rtl" ? "row-reverse" : "row",
            }}
          >
            <div>
              <i className="far fa-check-circle color-green-dark fa-3x pt-3 icon-80 text-center" />
            </div>
            <div>
              <h5 dir="auto" className="font-16 font-600">
                {t.about.feature3}
              </h5>
              <p dir="auto">{t.about.feature3sub}</p>
            </div>
          </div>
        </div>
      </div>
      <SocialLinks />
      <div className="card card-style">
        <div className="content text-center" dir="auto">
          {t.about.builtBy}
          <a href="https://othman.itechnopro.com"> @othmanosx </a>
          {t.about.sponsoredBy} <a href="https://www.itechnopro.com">iTECH</a>
        </div>
      </div>
    </div>
  )
}

export default AboutUs
